import styled from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';

export const ProvidersSectionWrapper = styled.div`
  ${WRAPPER}
  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ProvidersLazyWrapper = styled.div`
  min-height: 467px;

  @media (max-width: 768px) {
    min-height: 242px;
  }
`;
